// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gestion-comptes {
  margin: 0 auto;
  width: 100%;
}

.gestion-comptes h1 {
  margin-bottom: 3rem;
}

/* Style spécifique pour assurer que le menu d'actions est correctement positionné */
.action-menu-container {
  position: relative;
  display: inline-block;
}

.action-options-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  z-index: 1000;
  padding: 5px 0;
  margin-top: 5px;
}

.user-name,
.user-email,
.commande-count,
.commande-value,
.user-role,
.creation-date {
  font-size: 1.4rem;
  color: #2c3948;
}

.user-role {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #2c3948;
  cursor: pointer;
}

.user-role span {
  text-decoration: underline;
}

.user-role .edit-icon {
  width: 1.6rem;
  height: 1.6rem;
  color: #da7027;
}

.user-role:hover span {
  color: #da7027;
}

.user-role:hover .edit-icon {
  color: #c4631f;
}

/* Style pour la colonne Type */
.type-cell {
  font-size: 1.4rem;
  color: #2c3948;
}

.gestion-comptes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

/* Styles pour le modal de changement de rôle */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.change-role-modal {
  background-color: #fffdfc;
  /* padding: 2rem; */
  border-radius: 0.8rem;
  min-width: 40rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.change-role-modal h2 {
  margin-bottom: 1rem;
}

.change-role-modal p {
  margin-bottom: 2rem;
  color: #6b7280;
}

.role-options {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.role-button {
  padding: 0.8rem 1.6rem;
  border-radius: 0.4rem;
  border: 1px solid #e5e7eb;
  background-color: #fffdfc;
  cursor: pointer;
  font-size: 1.4rem;
  transition: all 0.2s ease;
}

.role-button:hover {
  background-color: #f9fafb;
}

.role-button.active {
  background-color: rgba(215, 217, 217, 0.2);
  border-color: #dbeafe;
  color: #484848;
}

.role-button.selected {
  background-color: #fcf1e7;
  border-color: #da7027;
  color: #da7027;
  box-shadow: 0 0 0 1px #da7027;
}

.role-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}

/* Style pour l'info-bulle du bouton "Créer un utilisateur" */
.button-with-tooltip[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  right: 0;
  background-color: #2c3948;
  color: white;
  padding: 0.8rem 1.2rem;
  border-radius: 0.4rem;
  font-size: 1.2rem;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-width: 30rem;
  white-space: normal;
  text-align: center;
}

.button-with-tooltip[title]:hover::before {
  content: '';
  position: absolute;
  bottom: 100%;
  right: 2rem;
  border: 0.5rem solid transparent;
  border-top-color: #2c3948;
  margin-bottom: -0.5rem;
}

/* Styles pour les colonnes de lots techniques et départements */
.lots-techniques,
.lots-departements {
  font-size: 1.3rem;
  line-height: 1.6;
  color: #2c3948;
}

.lots-techniques span,
.lots-departements span {
  display: block;
  margin: 0.2rem 0;
}

.no-lot {
  color: #9ca3af;
  font-style: italic;
}

/* Styles pour la modal de réattribution */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 1rem 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.8rem;
  color: #2c3948;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: color 0.2s ease;
}

.close-button:hover {
  color: #da7027;
}

.close-button svg {
  width: 2rem;
  height: 2rem;
}

.modal-body {
  padding: 2rem;
}

.info-section {
  background-color: rgba(194, 194, 194, 0.46);;
  border-radius: 0.6rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.info-row {
  display: flex;
  padding: 0.5rem 0;
}

.info-row:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

.info-label {
  font-weight: 600;
  color: #6b7280;
  min-width: 180px;
  font-size: 1.4rem;
}

.info-value {
  color: #2c3948;
  font-size: 1.4rem;
}

.form-group-modal {
  margin-top: 1.5rem;
}

.form-group-modal label {
  display: block;
  margin-bottom: 0.8rem;
  font-weight: 600;
  color: #2c3948;
  font-size: 1.4rem;
}

.form-select {
  width: 100%;
  padding: 1rem;
  border-radius: 0.6rem;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  color: #2c3948;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.form-select:hover {
  border-color: #da7027;
}

.form-select:focus {
  outline: none;
  border-color: #da7027;
  box-shadow: 0 0 0 3px rgba(218, 112, 39, 0.1);
}

.modal-actions {
  padding: 1rem 2rem 2rem 2rem;
  border-top: 1px solid #e5e7eb;
}

.actions-cell {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.modal-container {
  background-color: #fff;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
}
`, "",{"version":3,"sources":["webpack://./src/composants/GestionComptes/GestionComptes.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;EAME,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ","sourcesContent":[".gestion-comptes {\r\n  margin: 0 auto;\r\n  width: 100%;\r\n}\r\n\r\n.gestion-comptes h1 {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n/* Style spécifique pour assurer que le menu d'actions est correctement positionné */\r\n.action-menu-container {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.action-options-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  min-width: 220px;\r\n  z-index: 1000;\r\n  padding: 5px 0;\r\n  margin-top: 5px;\r\n}\r\n\r\n.user-name,\r\n.user-email,\r\n.commande-count,\r\n.commande-value,\r\n.user-role,\r\n.creation-date {\r\n  font-size: 1.4rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.user-role {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8rem;\r\n  color: #2c3948;\r\n  cursor: pointer;\r\n}\r\n\r\n.user-role span {\r\n  text-decoration: underline;\r\n}\r\n\r\n.user-role .edit-icon {\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n  color: #da7027;\r\n}\r\n\r\n.user-role:hover span {\r\n  color: #da7027;\r\n}\r\n\r\n.user-role:hover .edit-icon {\r\n  color: #c4631f;\r\n}\r\n\r\n/* Style pour la colonne Type */\r\n.type-cell {\r\n  font-size: 1.4rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.gestion-comptes-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Styles pour le modal de changement de rôle */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.change-role-modal {\r\n  background-color: #fffdfc;\r\n  /* padding: 2rem; */\r\n  border-radius: 0.8rem;\r\n  min-width: 40rem;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.change-role-modal h2 {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.change-role-modal p {\r\n  margin-bottom: 2rem;\r\n  color: #6b7280;\r\n}\r\n\r\n.role-options {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.role-button {\r\n  padding: 0.8rem 1.6rem;\r\n  border-radius: 0.4rem;\r\n  border: 1px solid #e5e7eb;\r\n  background-color: #fffdfc;\r\n  cursor: pointer;\r\n  font-size: 1.4rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.role-button:hover {\r\n  background-color: #f9fafb;\r\n}\r\n\r\n.role-button.active {\r\n  background-color: rgba(215, 217, 217, 0.2);\r\n  border-color: #dbeafe;\r\n  color: #484848;\r\n}\r\n\r\n.role-button.selected {\r\n  background-color: #fcf1e7;\r\n  border-color: #da7027;\r\n  color: #da7027;\r\n  box-shadow: 0 0 0 1px #da7027;\r\n}\r\n\r\n.role-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Style pour l'info-bulle du bouton \"Créer un utilisateur\" */\r\n.button-with-tooltip[title]:hover::after {\r\n  content: attr(title);\r\n  position: absolute;\r\n  bottom: 100%;\r\n  right: 0;\r\n  background-color: #2c3948;\r\n  color: white;\r\n  padding: 0.8rem 1.2rem;\r\n  border-radius: 0.4rem;\r\n  font-size: 1.2rem;\r\n  white-space: nowrap;\r\n  z-index: 1000;\r\n  margin-bottom: 0.5rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n  max-width: 30rem;\r\n  white-space: normal;\r\n  text-align: center;\r\n}\r\n\r\n.button-with-tooltip[title]:hover::before {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  right: 2rem;\r\n  border: 0.5rem solid transparent;\r\n  border-top-color: #2c3948;\r\n  margin-bottom: -0.5rem;\r\n}\r\n\r\n/* Styles pour les colonnes de lots techniques et départements */\r\n.lots-techniques,\r\n.lots-departements {\r\n  font-size: 1.3rem;\r\n  line-height: 1.6;\r\n  color: #2c3948;\r\n}\r\n\r\n.lots-techniques span,\r\n.lots-departements span {\r\n  display: block;\r\n  margin: 0.2rem 0;\r\n}\r\n\r\n.no-lot {\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n}\r\n\r\n/* Styles pour la modal de réattribution */\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 2rem 2rem 1rem 2rem;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  font-size: 1.8rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.close-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #6b7280;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.close-button:hover {\r\n  color: #da7027;\r\n}\r\n\r\n.close-button svg {\r\n  width: 2rem;\r\n  height: 2rem;\r\n}\r\n\r\n.modal-body {\r\n  padding: 2rem;\r\n}\r\n\r\n.info-section {\r\n  background-color: rgba(194, 194, 194, 0.46);;\r\n  border-radius: 0.6rem;\r\n  padding: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.info-row {\r\n  display: flex;\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.info-row:not(:last-child) {\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.info-label {\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  min-width: 180px;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.info-value {\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.form-group-modal {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.form-group-modal label {\r\n  display: block;\r\n  margin-bottom: 0.8rem;\r\n  font-weight: 600;\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.form-select {\r\n  width: 100%;\r\n  padding: 1rem;\r\n  border-radius: 0.6rem;\r\n  border: 1px solid #d1d5db;\r\n  font-size: 1.4rem;\r\n  color: #2c3948;\r\n  background-color: white;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.form-select:hover {\r\n  border-color: #da7027;\r\n}\r\n\r\n.form-select:focus {\r\n  outline: none;\r\n  border-color: #da7027;\r\n  box-shadow: 0 0 0 3px rgba(218, 112, 39, 0.1);\r\n}\r\n\r\n.modal-actions {\r\n  padding: 1rem 2rem 2rem 2rem;\r\n  border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.actions-cell {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  align-items: center;\r\n}\r\n\r\n.modal-container {\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  max-width: 600px;\r\n  width: 90%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
